import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { AccessRevocation, DocumentDownload, ExitClearance, ExitInterview, FinalSettlement, Separation, StatusTracking, TerminationAppeal } from '../models/separation';
import { Message } from '../models/domain';

@Injectable({
  providedIn: 'root'
})
export class SeparationService {

  constructor(private httpClient: HttpClient) { }

  // SEPARATION //
  public createSeparation(separation: Separation): Observable<Message> {
    return this.httpClient.post<Message>(`/api/separation/v1`, separation)
  }
  public getSeparations(hr: boolean, status?: string, fromDate?: string, toDate?: string, disabled?: boolean): Observable<Separation[]> {
    return this.httpClient.get<Separation[]>(`/api/separation/v1`, { params: { hr, ...(status && { status }), ...(fromDate && { fromDate }), ...(toDate && { toDate }), ...(disabled && { disabled }) } });
  }
  public getTerminations(hr: boolean, status?: string, fromDate?: string, toDate?: string, disabled?: boolean): Observable<Separation[]> {
    return this.httpClient.get<Separation[]>(`/api/separation/v1/termination`, { params: { hr, ...(status && { status }), ...(fromDate && { fromDate }), ...(toDate && { toDate }), ...(disabled && { disabled }) } });
  }
  public getSeparation(id: number): Observable<Separation> {
    return this.httpClient.get<Separation>(`/api/separation/v1/${id}`);
  }
  public getStatus(): Observable<string> {
    return this.httpClient.get<string>(`/api/separation/v1/exit-status`);
  }

  // SEPARATION CHECK API's //
  public checkReprtdToAndAdrsTo(): Observable<boolean> {
    return this.httpClient.get<boolean>(`/api/separation/v1/is-apply`);
  }
  public isActiveSeparation(): Observable<boolean> {
    return this.httpClient.get<boolean>(`/api/separation/v1/is-active`);
  }

  // STATUS TRACKING //
  public createStatusTracking(statusTracking: StatusTracking): Observable<Message> {
    return this.httpClient.post<Message>(`/api/separation/v1/separation-status-tracking`, statusTracking);
  }
  public updateStatusTracking(id: number, statusTracking: StatusTracking): Observable<Message> {
    return this.httpClient.put<Message>(`/api/separation/v1/separation-status-tracking/${id}`,statusTracking);
  }
  public getStatusTrackings(separationId: number): Observable<StatusTracking[]> {
    return this.httpClient.get<StatusTracking[]>(`/api/separation/v1/separation-status-tracking`, { params: { separationId } });
  }
  public getLOneStatusTrackings(): Observable<StatusTracking[]> {
    return this.httpClient.get<StatusTracking[]>(`/api/separation/v1/separation-status-tracking/approver`);
  }

  // EXIT INTERVIEW //
  public createExitInterview(exitInterview: ExitInterview): Observable<Message> {
    return this.httpClient.post<Message>(`/api/separation/v1/exit-interview`, exitInterview);
  }
  public getExitInterviews(separationId: number): Observable<ExitInterview[]> {
    return this.httpClient.get<ExitInterview[]>(`/api/separation/v1/exit-interview`, { params: { separationId } });
  }

  // ACCESS REVOCATION //
  public createAccessRevocation(accessRevocation: AccessRevocation): Observable<Message> {
    return this.httpClient.post<Message>(`/api/separation/v1/access-revocation`, accessRevocation);
  }
  public getAccessRevocations(separationId: number): Observable<AccessRevocation[]> {
    return this.httpClient.get<AccessRevocation[]>(`/api/separation/v1/access-revocation`, { params: { separationId } });
  }

  // EXIT CLEARANCE //
  public createExitClearance(exitClearance: ExitClearance): Observable<Message> {
    return this.httpClient.post<Message>(`/api/separation/v1/exit-clearance`, exitClearance);
  }
  public getExitClearances(separationId: number): Observable<ExitClearance[]> {
    return this.httpClient.get<ExitClearance[]>(`/api/separation/v1/exit-clearance`, { params: { separationId } });
  }
  public getExitSatus(): Observable<string> {
    return this.httpClient.get<string>(`/api/separation/v1/exit-clearance-status`);
  }

  // FINAL SETTLEMENT //
  public createFinalSettlement(finalSettlement: FinalSettlement): Observable<Message> {
    return this.httpClient.post<Message>(`/api/separation/v1/final-settlement`, finalSettlement);
  }
  public getFinalSettlements(separationId: number): Observable<FinalSettlement[]> {
    return this.httpClient.get<FinalSettlement[]>(`/api/separation/v1/final-settlement`, { params: { separationId } });
  }
  public getFinalStatus(): Observable<string> {
    return this.httpClient.get<string>(`/api/separation/v1/final-settlement-status`);
  }

  // DOCUMENT DOWNLOAD //
  public createDocumentDownload(documentDownload: DocumentDownload): Observable<Message> {
    return this.httpClient.post<Message>(`/api/separation/v1/document-download`, documentDownload);
  }
  public deleteDocument(id: number): Observable<Message> {
    return this.httpClient.delete<Message>(`/api/separation/v1/document-download/${id}`)
  }
  public getDocumentType(): Observable<string> {
    return this.httpClient.get<string>(`/api/separation/v1/document-download/type`);
  }
  public getDocumentDownload(id: number): Observable<DocumentDownload> {
    return this.httpClient.get<DocumentDownload>(`/api/separation/v1/document-download/${id}`);
  }
  public getDocumentDownloads(separationId: number): Observable<DocumentDownload[]> {
    return this.httpClient.get<DocumentDownload[]>(`/api/separation/v1/document-download`, { params: { separationId } });
  }
  public uploadFile(documentId: number, file: FormData): Observable<Message> {
    return this.httpClient.post<Message>(`/api/separation/v1/document-download/upload`, file, { params: { documentId } });
  }

  // TERMINATION APPEAL //
  public createTerminationAppeal(terminationAppeal: TerminationAppeal): Observable<Message> {
    return this.httpClient.post<Message>(`/api/separation/v1/employee-termination-appeal`, terminationAppeal);
  }
  public updateTerminationAppeal(id: number, terminationAppeal: TerminationAppeal): Observable<Message> {
    return this.httpClient.put<Message>(`/api/separation/v1/employee-termination-appeal/${id}`,terminationAppeal);
  }
  public getTerminationAppeal(separationId: number): Observable<TerminationAppeal[]> {
    return this.httpClient.get<TerminationAppeal[]>(`/api/separation/v1/employee-termination-appeal`, { params: { separationId } });
  }
  public getAppealStatus(): Observable<string> {
    return this.httpClient.get<string>(`/api/separation/v1/employee-termination-appeal/status`);
  }

}
